//  @flow

import { connect } from 'react-redux';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';

// Components
import ContentFooter from './ContentFooter';

// Actions
import { changeLocale } from 'store/reducers/dealerData/actions';

// Selectors
import { getTranslate } from 'store/reducers/localizationString/selectors';
import {
  getLanguagesAvailable,
  languagesAvailableGreaterThanOne,
  getDealerLocaleName
} from 'store/reducers/dealerSettings/selectors';
import { getLocaleCode } from 'store/reducers/dealerLocale/selectors';

const mapStateToProps = state => ({
  localizationStrings: getTranslate(state),
  getLanguagesAvailable: getLanguagesAvailable(state),
  languagesAvailableGreaterThanOne: languagesAvailableGreaterThanOne(state),
  dealerLocaleName: getDealerLocaleName(state),
  getLocaleCode: getLocaleCode(state)
});

export default compose(
  injectIntl,
  connect(
    mapStateToProps,
    {
      changeLocale
    }
  )
)(ContentFooter);



// WEBPACK FOOTER //
// ./src/components/pages/components/ContentFooter/ContentFooterContainer.js